/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown> }} Drastic_Tech_Importing_File_LogInputs */



/**
* | output |
* | --- |
* | "Importing {format} file..." |
*
* @param {Drastic_Tech_Importing_File_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_importing_file_log = /** @type {((inputs: Drastic_Tech_Importing_File_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Importing_File_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importation du fichier ${i?.format}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Importiere die Datei ${i?.format}...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione del file ${i?.format}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт файла ${i?.format}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importando archivo ${i?.format}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在导入${i?.format}文件...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.format} ファイルをインポートしています...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल आयात की जा रही है...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Importando o arquivo ${i?.format}...`)
	return /** @type {LocalizedString} */ (`Importing ${i?.format} file...`)
});